import { Pages } from "../../../utils";
import { ActionButton } from "../components/Button";
import { IconArrowRight } from "../components/Icons";
import { heroStats } from "../data";
import matchingHeroImage from "../../../assets/home-page/matching/section1.png";

type HeroSectionProps = {
  onScrollToHowItWorks: () => void;
};

export const HeroSection = ({ onScrollToHowItWorks }: HeroSectionProps) => (
  <section className="sg-hero">
    <div className="sg-container sg-hero__layout">
      <div className="sg-hero__grid">
        <div className="sg-hero__content">
          <span className="sg-hero__kicker">How Matching Works</span>
          <h1 className="sg-hero__title">
            <span className="sg-hero__title-line">Smart-Guild</span>
            <span className="sg-hero__title-line is-accent">Matching</span>
            <span className="sg-hero__title-line is-accent">Technology</span>
          </h1>
          <p className="sg-hero__lead">
            We match homeowners with interior designers based on personality,
            preferences, and project needs - ensuring your design journey
            flourishes from the very start.
          </p>
          <div className="sg-hero__actions">
            <ActionButton size="lg" to={Pages.PERSONALITY_QUIZ}>
              Take the Personality Quiz <IconArrowRight size={20} />
            </ActionButton>
            <ActionButton
              variant="outline"
              size="lg"
              onClick={onScrollToHowItWorks}
            >
              See How It Works
            </ActionButton>
          </div>
        </div>

        <div className="sg-hero__visual">
          <img
            src={matchingHeroImage}
            alt="Smart-Guild matching preview"
            className="sg-hero__image"
          />
        </div>

        <div className="sg-hero__stats">
          {heroStats.map((stat) => (
            <div key={stat.label} className="sg-hero__stat">
              <div className="sg-hero__stat-value">{stat.value}</div>
              <div className="sg-hero__stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
